module.exports = __webpack_public_path__ + "img/map-marker-alt-solid.4ce98005.svg";